<div class="bg-[#EDEEF4]">
  <div class="w-11/12 mx-auto py-8 flex flex-col gap-4">
    <div class=" hidden md:block">
      <div class="text-sm flex justify-end">
        <span routerLink="/service-by-group/sector"
              class="p-2 pb-1 bg-white hover:!bg-primary-500 hover:text-white transition-all duration-300 rounded-t-2xl cursor-pointer ">
          {{ 'View All' | concat | translate }}
        </span>
      </div>
      <div #tabGrid
           class="bg-white p-3 rounded-b-2xl rounded-tl-2xl md:grid gap-3"
           [style.grid-template-columns]="'repeat(' + visibleTabCount + ', minmax(0, 1fr))'">
        @for (tab of visibleTabs; track tab.slug) {
          <div matRipple
               [attr.data-tab-slug]="tab.slug"
               (keyup)="$event.stopPropagation()"
               (click)="changeTab(tab?.slug)"
               (mouseenter)="onTabIconHover($event, tab.slug, true)"
               (mouseleave)="onTabIconHover($event, tab.slug, false)"
               [ngClass]="{'bg-[#2A4F97] text-white': tab.slug === activeTab,
          'bg-[#e7e8e9] hover:bg-[#2A4F97] hover:text-white': tab.slug !== activeTab}"
               class="p-2 min-w-0 flex items-center cursor-pointer justify-center gap-2 rounded-xl group transition-all duration-300 intro-x">
            @if (tabIcons[tab.slug]) {
              <div
                [ngClass]="{'border-2': tab.slug === activeTab,
              'border-0': tab.slug !== activeTab}"
                class="border-white rounded-full h-16 w-16 shrink-0 flex items-center justify-center">
                <div class="tab-icon p-2 h-14 w-14 flex items-center justify-center"
                     [innerHTML]="tabIcons[tab.slug]"></div>
              </div>
            }
            <span class="min-w-0 py-2 pr-2.5 text-center font-bold">{{ tab?.slug === 'popular' ? (tab?.name | concat | translate) : tab?.name }}</span>
          </div>
        }
      </div>
    </div>

    <div class="flex gap-3 flex-wrap md:hidden">
      @for (tab of tabs; track tab.slug) {
        <div matRipple
             [attr.data-tab-slug]="tab.slug"
             (keyup)="$event.stopPropagation()"
             (click)="changeTab(tab?.slug)"
             (mouseenter)="onTabIconHover($event, tab.slug, true)"
             (mouseleave)="onTabIconHover($event, tab.slug, false)"
             [ngClass]="{'bg-[#2A4F97] text-white': tab.slug === activeTab,
          'bg-[#e7e8e9] hover:bg-[#2A4F97] hover:text-white': tab.slug !== activeTab}"
             class="min-w-0 flex items-center cursor-pointer justify-center gap-2 rounded-xl group transition-all duration-300 intro-x">
          @if (tabIcons[tab.slug]) {
            <div class="tab-icon p-2 h-8 w-8 flex items-center justify-center" [innerHTML]="tabIcons[tab.slug]"></div>
          }
          <span class="min-w-0 py-2 pr-2.5 text-center">{{ tab?.name }}</span>
        </div>
      }
    </div>

    <div class="grid grid-cols-12 gap-2.5">
      @for (service of services; track service?.id) {
        <div
          (click)="onOpenServiceDetails(service)" (keyup)="$event.stopPropagation()"
          class="col-span-12 md:col-span-3 group border-b-2 border-b-white cursor-pointer
         hover:border-b-secondary hover:shadow-md hover:shadow-gray-300 transition-all duration-300 bg-white p-2 rounded-xl
         flex items-center gap-2 text-primary-500 intro-x min-w-0">
          <div class="!h-14 !w-14 shrink-0 rounded-full flex items-center justify-center bg-[#43548D]">
            <mat-icon class="!scale-125" svgIcon="new-service"></mat-icon>
          </div>
          <div class="grow min-w-0 text-sm flex flex-col">
            <span>{{ service?.serviceName }}</span>
            <span class="!text-[10px] hidden group-hover:block">{{ service?.serviceProvider?.institutionName }}</span>
          </div>
          <mat-icon class="shrink-0">chevron_right</mat-icon>
        </div>
      }

      @if (!services?.length && !isLoadingService) {
        <div class="col-span-12 flex items-center justify-center h-48 text-gray">
          <span>{{ 'No services found for this category' | concat | translate }}</span>
        </div>
      }
      @if (isLoadingService)  {
        <div class="col-span-12 flex items-center justify-center h-48 text-gray">
          <mat-spinner class="text-primary-500 !h-12 !w-12"></mat-spinner>
        </div>
      }
    </div>

    <div class="flex flex-col gap-2.5">
      <span class="font-black text-lg text-primary-500">{{ 'Specific Group Directory' | concat | translate }}</span>

      <div class="grid grid-cols-1 md:grid-cols-6 gap-4 items-center justify-between">
        @for (group of specificDirectory; track $index) {
          <div
            matRipple
            [routerLink]="group.url"
            class="directory-card group bg-white p-6 rounded-xl flex flex-col items-center
             justify-center gap-3 cursor-pointer transition-all duration-300 hover:shadow-lg"
            (mouseenter)="onDirectoryIconHover($event, true)"
            (mouseleave)="onDirectoryIconHover($event, false)">
            <div
              class="directory-icon group-hover:bg-[#43548D] transition-all duration-300 flex items-center border-4 border-[#43548D] rounded-full  justify-center h-24 w-24"
            >
              <div class="h-12 w-12 flex items-center justify-center" [innerHTML]="directoryIcons[group.name]"></div>
            </div>
            <span class="text-primary-500 text-center font-medium">{{ group?.name | concat | translate }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
